module.exports = __webpack_public_path__ + "static/media/love_how_you_feel_dance_fitness_class.e24b4268.webp";